import { useMutation, useQuery } from "@tanstack/react-query";
import { getBillingChargeableEnquiry, getBillingInvoiceEnquiry } from "services/data.report.service";
import { TableCard } from "ui-components/Layout";
import { ListLayout } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import { BillingChargeableColumns } from "layouts/views/enquiry/columns";
import { useState } from "react";
import { useCustomerValue } from "providers/CustomerContext";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { CSVLink } from "react-csv";
import { Texts } from "ui-components/Form";
import { Grid } from "@mui/material";
import { CustomDateRangePicker } from "ui-components/CustomInput";
import dayjs from "dayjs";
import { Error_ } from "ui-components/Alert";
import { LoadingDialog } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import { ExportDialog } from "ui-components/Alert";

function BillingChargeableEnquiry() {
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const [data, setData] = useState([]);
  const date = dayjs(new Date()).format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(date);
  const [endDate, setEndDate] = useState(date);
  const [filteredData, setFilteredData] = useState([]);
  const handleFilterRowsChange = (filteredData) => { setFilteredData(filteredData); };
  const { downloadCsv, isDownloading } = useCsvDownloadHook();
  
  const { permissions, allowAll } = useTeamValue()
  const exportPermission = allowAll || (Boolean(permissions["Billing Chargeable_Report"]) && permissions["Billing Chargeable_Report"].findIndex(b => b === "export") !== -1);
  const viewPricePermission =
  (Boolean(permissions["Team Role"]) && permissions["Team Role"].some(a => a === "access")) ||
   (Boolean(permissions["Billing Setup"]) &&
    permissions["Billing Setup"].findIndex((b) => b === "viewPrice") !== -1);

  const { refetch, isFetching } = useQuery({
    queryKey: ["billing-chargeable-enquiry", { customerCode }],
    queryFn: () => getBillingChargeableEnquiry({ customerCode, startDate, endDate, viewPricePermission }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => { setData(data.data.data); setFilteredData(data.data.data); },
    onError: () => { },
  });

  const customProps = { startDate, setStartDate, endDate, setEndDate };

  const onFetch = () => {
    setAlert(null);
    const valid =
      dayjs(endDate).isSame(dayjs(startDate)) || dayjs(endDate).isAfter(dayjs(startDate));
    if (!valid) {
      setAlert(<Error_ content="Start Date cannot be greater than End Date" onChange={setAlert} />);
      return;
    }
    if (dayjs(date).isBefore(endDate)) {
      setAlert(<Error_ content="End Date cannot be greater than Today's Date" onChange={setAlert} />);
      return;
    }
    refetch();
  };

  const fetchMultiSheetExcel = async () => {
    setAlert(null);
    const valid =
      dayjs(endDate).isSame(dayjs(startDate)) || dayjs(endDate).isAfter(dayjs(startDate));

    if (!valid) {
      setAlert(<Error_ content="Start Date cannot be greater than End Date" onChange={setAlert} />);
      return;
    }
    if (dayjs(date).isBefore(endDate)) {
      setAlert(<Error_ content="End Date cannot be greater than Today's Date" onChange={setAlert} />);
      return;
    }

    try {
      const response = await getBillingInvoiceEnquiry({ customerCode, startDate, endDate, invoiceNumber: "INV/2501/000127" }); console.log('response', response);
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${customerCode}_INV/2501/000127_${dayjs().format("YYYYMMDDHHmmss")}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      setAlert(<Error_ content="Error exporting Excel file" onChange={setAlert} />);
    }
  };

  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}
      {isDownloading && <ExportDialog />}
      {alert && <MDBox sx={{ my: 3 }}>{alert}</MDBox>}

      <TableCard sx={{ my: 3 }}>
        <MDBox margin="1rem 0 0 1rem">
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <CustomDateRangePicker {...customProps} />
            </Grid>
            <Grid item xs={4}>
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => {
                  onFetch();
                }}
              >
                search
              </MDButton>
              {/* <MDButton sx={{ marginLeft: "1rem" }} variant="gradient" color="info" disabled={!exportPermission}>
                <CSVLink style={{ color: "white" }} filename={`Billing-Chargeable`} data={filteredData}>
                  export
                </CSVLink>
              </MDButton> */}
              <MDButton
                sx={{ marginLeft: "1rem" }}
                variant="gradient"
                color="info"
                disabled={!exportPermission}
                onClick={() => {
                  const filename = `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_BillingChargeable`;
                  downloadCsv(filename, filteredData)
                }}
              >
                export
              </MDButton>
              {/* <MDButton sx={{ marginLeft: "1rem" }} variant="gradient" color="info" disabled={!exportPermission} onClick={() => {fetchMultiSheetExcel();}}>
                Test INV/2501/000127
              </MDButton> */}
            </Grid>
          </Grid>
        </MDBox>

        <BasicTable data={data} columns={BillingChargeableColumns} onFilterRowsChange={handleFilterRowsChange} />
      </TableCard>
    </ListLayout>
  );
}

export default BillingChargeableEnquiry;
